import { MenuItem, styled } from '@mui/material';
import { BiFile } from 'react-icons/bi';
import { useImageContext } from '../../imageContext';

const UnselectedFileElement = styled(MenuItem)({
  backgroundColor:'#FFFFFF',
  height: '25px'
});

const HighlightedFileElement = styled(MenuItem)({
  backgroundColor:'#FFFFFF',
  height: '25px',
  fontWeight: 'bold'
});

const SelectedFileElement = styled(MenuItem)({
  backgroundColor: '#D3D3D3',
  height: '25px',
  fontWeight: 'bold'
});

export interface ImageFileProps {
  item: string;
  readOnly: boolean | undefined;
  highlight: boolean | undefined;
}

export const ImageFile = (props: ImageFileProps): JSX.Element => {
  const { selected, setSelected } = useImageContext();

  const handleClick = (): void => {
    if (selected === props.item) {
      setSelected('');
    } else {
      setSelected(props.item);
    }
  };

  if (selected === props.item) {
    return (
      <SelectedFileElement
        autoFocus={true}
        onClick={() => handleClick()}
        data-testid={`id-${props.item}`}
        key={`id-${props.item}`}
        disabled={props.readOnly}
      >
        <BiFile /> {props.item}
      </SelectedFileElement>
    );
  } else if (props.highlight) {
    return (
      <HighlightedFileElement
        onClick={() => handleClick()}
        data-testid={`id-${props.item}`}
      >
        <BiFile /> {props.item}
      </HighlightedFileElement>
    );
  } else {
    return (
      <UnselectedFileElement
        onClick={() => handleClick()}
        data-testid={`id-${props.item}`}
      >
        <BiFile /> {props.item}
      </UnselectedFileElement>
    );
  }
};
